import type { USPValue } from "@/types/sites";
import styles from "./USPAttributesIcon.module.css";
import { CmsImage } from "@/components/common/CmsImage";

type USPAttributesIconProps = ({
    attribute,
}: {
    attribute: USPValue;
}) => React.ReactElement;

export const USPAttributesIcon: USPAttributesIconProps = ({ attribute }) => {
    const uspLogo = attribute?.attribution?.data?.attributes?.logo || null;

    const attributionTitle =
        attribute?.attribution?.data?.attributes?.attribution;
    const uspTitle = attribute.attribution_title;

    const attributionSubTitle =
        attribute?.attribution?.data?.attributes?.attribution_desc;
    const uspSubTitle = attribute.attribution_desc;

    return (
        <div className={styles.iconContainer}>
            <div>
                <CmsImage cmsMedia={uspLogo} desiredHeight={40} loading="eager"/>
            </div>
            <p className={styles.attributionTitle}>
                {uspTitle ?? attributionTitle ?? ""}
            </p>
            <p className={styles.attributionSubTitle}>
                {uspSubTitle ?? attributionSubTitle ?? ""}
            </p>
        </div>
    );
};
